document.addEventListener('DOMContentLoaded', function () {
  // ===== MYBODY UI QTY LOCK ONLY =====
  // Purpose: prevent users changing quantity in the cart UI
  // No cart mutations, no fetch hooks, no qty clamping

  if (window.__MYBODY_UI_LOCK__) return;
  window.__MYBODY_UI_LOCK__ = true;

  // Only lock these frequency-linked MyBody variants
  const MYBODY_FREQ_VARIANTS = [
    '51534943191327', // 1 month
    '51562885546271', // 3 month
    '51562885579039'  // 6 month
  ];

  function lockMyBodyQtyUi() {
    document.querySelectorAll('.ymq-cart-app-item').forEach(item => {
      const variantId = item.getAttribute('ymq-cart-app-item-id');
      if (!MYBODY_FREQ_VARIANTS.includes(String(variantId))) return;
      if (item.dataset.myBodyLocked) return;

      item.dataset.myBodyLocked = 'true';

      const qtyInput = item.querySelector('.ymq-cart-app-item-quantity-input');
      if (qtyInput) {
        qtyInput.disabled = true;
        qtyInput.readOnly = true;
        qtyInput.style.opacity = '0.6';
        qtyInput.style.cursor = 'not-allowed';
      }

      item
        .querySelectorAll(
          '.ymq-cart-app-item-quantity-minus, .ymq-cart-app-item-quantity-plus'
        )
        .forEach(btn => {
          if (!btn) return;
          btn.style.pointerEvents = 'none';
          btn.style.opacity = '0.4';
          btn.style.cursor = 'not-allowed';
        });
    });
  }

  // Initial run
  setTimeout(lockMyBodyQtyUi, 300);

  // Re-run when cart drawer updates
  const attachObserver = (target) => {
    const mo = new MutationObserver(() => {
      setTimeout(lockMyBodyQtyUi, 200);
    });
    mo.observe(target, { childList: true, subtree: true });
  };

  const cartApp = document.getElementById('ymq-cart-app');
  if (cartApp) {
    attachObserver(cartApp);
  } else {
    const bodyObserver = new MutationObserver(() => {
      const cart = document.getElementById('ymq-cart-app');
      if (cart) {
        attachObserver(cart);
        bodyObserver.disconnect();
      }
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
